module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-economypost-edit"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "cols cols-3"
  }, [_c('inputfield', [_c('label', [_vm._v("Kunde")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.client_key),
      expression: "economypost.client_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.economypost, "client_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ingen relevant kunde")]), _vm._v(" "), _vm._l((_vm.clients), function(client, key, i) {
    return _c('option', {
      attrs: {
        "value": ""
      },
      domProps: {
        "value": key
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(client.name) + "\t\t\t\t\t\t\n\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Opgave")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.project_key),
      expression: "economypost.project_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.economypost, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ingen relevant opgave")]), _vm._v(" "), _vm._l((_vm.projects), function(project, key, i) {
    return _c('option', {
      attrs: {
        "value": ""
      },
      domProps: {
        "value": key
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(project.name) + "\n\t\t\t\t\t"), (project.client_key && _vm.clients[project.client_key]) ? [_vm._v("\n\t\t\t\t\t- " + _vm._s(_vm.clients[project.client_key].name) + "\n\t\t\t\t\t")] : _vm._e()], 2)
  })], 2)]), _vm._v(" "), (!_vm.economypost.project_key || !_vm.economypost.project_key.length) ? _c('inputfield', [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.title),
      expression: "economypost.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "title", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Beløb eks. moms")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.economypost.amount_dkk_ex_vat),
      expression: "economypost.amount_dkk_ex_vat",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.economypost.amount_dkk_ex_vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "amount_dkk_ex_vat", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (false && _vm.economypost.project_key) ? _c('p', [_vm._v("\n\t\t\t\t\tProject budget:"), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.outputMoney(_vm.getProjectBudgetTotal(_vm.getProject(_vm.economypost.project_key)), 'a')) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Faktureringsdato")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.invoice_date),
      expression: "economypost.invoice_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.economypost.invoice_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "invoice_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Note")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.note),
      expression: "economypost.note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Faktura #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.economypost.invoice_no),
      expression: "economypost.invoice_no",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.invoice_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "invoice_no", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Betalingsfrist")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.payment_due_date),
      expression: "economypost.payment_due_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.economypost.payment_due_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "payment_due_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.invoiced),
      expression: "economypost.invoiced"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12bfds3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.invoiced) ? _vm._i(_vm.economypost.invoiced, null) > -1 : (_vm.economypost.invoiced)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.invoiced,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "invoiced", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "invoiced", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "invoiced", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12bfds3kj"
    }
  }, [_vm._v("Faktureret")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.paid),
      expression: "economypost.paid"
    }],
    attrs: {
      "type": "checkbox",
      "id": "fdsdf"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.paid) ? _vm._i(_vm.economypost.paid, null) > -1 : (_vm.economypost.paid)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.paid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "paid", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "paid", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "paid", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fdsdf"
    }
  }, [_vm._v("Betalt")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.hypothetic),
      expression: "economypost.hypothetic"
    }],
    attrs: {
      "type": "checkbox",
      "id": "jn2jkhb"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.hypothetic) ? _vm._i(_vm.economypost.hypothetic, null) > -1 : (_vm.economypost.hypothetic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.hypothetic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "hypothetic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "hypothetic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "hypothetic", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "jn2jkhb"
    }
  }, [_vm._v("Hypotetisk")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cols cols-3"
  }, [_c('btn', {
    attrs: {
      "block": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.archiveEconomypost()
      }
    }
  }, [_vm._v("Slet")]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'economypost',
      "keyis": _vm.economypost['.key']
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "killer",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed92f62a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modal-economypost-edit.vue
// module id = 627
// module chunks = 1